<template>
  <svg
    :style="iconStyle"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path :d="iconPath" />
  </svg>
</template>

<script>
import * as mdiIcons from '@mdi/js';
import { computed } from 'vue';


export default {
  name: 'MdiIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    iconSize: {
      type: [String,Number],
      default: '1.5'
    }
  },
  setup(props) {
    let iconName = props.name.substring(0);

    // Remove the mdi prefix if it exists
    if (iconName.startsWith('mdi')) {
      iconName = iconName.slice(3);
    }
    
    // Convert the icon name to camel case, including the first letter
    iconName = iconName.charAt(0).toUpperCase() + iconName.slice(1);
    iconName = 'mdi' + iconName.replace(/-([a-z])/g, g => g[1].toUpperCase());


    // Check if the icon exists in the mdiIcons object
    if (!mdiIcons[iconName]) {
      console.warn(`Icon ${iconName} not found`);
      iconName = 'mdiAlertCircle';
    }

    const iconStyle = computed (() => {
      return {
        width: `${props.iconSize}em`,
        height: `${props.iconSize}em`
      }
    });

    return {
      iconPath: mdiIcons[iconName],
      iconStyle
    };
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>